module.exports = __webpack_public_path__ + "assets/img/card_1.afcac954.svg";